import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter , HashRouter} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter >
    {/* <BrowserRouter> */}
    {/* <HashRouter> */}
      <AuthProvider>      
          <App />      
      </AuthProvider>
    </BrowserRouter>

  </React.StrictMode>
);
